import { useEffect, useState } from "react";
import axios from "axios";
import { FadeUp } from "@/components/motion";
import { ShieldCheck, FileDown } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ClientProtection() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    axios.get(`${API}/client-protection/status`).then((r) => setAvailable(!!r.data?.available)).catch(() => {});
  }, []);

  return (
    <section data-testid="client-protection" id="client-protection" className="relative bg-[#0A0A0A] py-24 md:py-32 scroll-mt-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <FadeUp>
          <div className="border border-[#27272A] bg-[#141414] p-8 md:p-14 grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <p className="tracking-label text-[11px] uppercase font-body font-bold text-[#DFFF00] mb-5 flex items-center gap-2">
                <ShieldCheck size={14} /> Client Protection
              </p>
              <h2 className="font-display font-bold tracking-tighter leading-[0.98] text-3xl md:text-5xl text-[#F8F8F5]">
                Clear information. <span className="font-serif-accent font-light">Fair service.</span>
              </h2>
              <p className="mt-6 font-body text-base md:text-lg text-[#A1A1AA] leading-relaxed max-w-xl">
                Barrett Career Brand is committed to clear expectations, respectful service and the
                careful handling of client information.
              </p>
              <p className="mt-4 font-body text-base md:text-lg text-[#A1A1AA] leading-relaxed max-w-xl">
                Our Client Protection Pack explains our service terms, refunds and consumer rights,
                privacy and data protection, and complaints process.
              </p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              {available ? (
                <a
                  href={`${API}/client-protection/pack`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="client-protection-download-btn"
                  className="rounded-full bg-[#DFFF00] text-[#0A0A0A] font-body font-semibold px-8 py-4 inline-flex items-center gap-2 hover:bg-[#C8E600] transition-colors duration-300"
                >
                  <FileDown size={18} /> Download Client Protection Pack PDF
                </a>
              ) : (
                <p data-testid="client-protection-pending" className="font-body text-sm text-[#52525B] max-w-[220px] lg:text-right">
                  The Client Protection Pack PDF will be available for download here shortly.
                </p>
              )}
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
